import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M106.5 84.53c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path fill="#D8FFFF" d="M80.49 8.3a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="M4.98 63.21a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M20.6 96.77l3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM101.5 27.31h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path fill="#0597A3" d="m23.89 47.24 31.71-21.8 36.51 21.8L59 77.03z" />
    <path
      fill="#00D8D8"
      d="M67.2 18.57H40.91c-2.12 0-3.84 1.72-3.84 3.84v44.84c0 2.12 1.72 3.84 3.84 3.84h36.17c2.12 0 3.84-1.72 3.84-3.84V32.29L67.19 18.56z"
    />
    <path
      fill="#0597A3"
      d="M70 32.3h10.92L67.19 18.57v10.92c0 1.55 1.26 2.81 2.81 2.81"
    />
    <path
      fill="#D8FFFF"
      d="M23.89 47.24V81.8c0 2.87 2.33 5.2 5.2 5.2h57.82c2.87 0 5.2-2.33 5.2-5.2V47.24L68.82 65.97c-.93.74-2.08 1.15-3.26 1.15H52.34c-1.12 0-2.21-.36-3.11-1.03L23.9 47.24z"
    />
    <path
      fill="#001A43"
      d="M69.51 41.48H48.49c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h21.02c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M69.51 52.65H48.49c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h21.02c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
  </svg>
);
const SvgEnrichedIconOwnerInvoicesBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconOwnerInvoicesBrand);
export default Memo;
